import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session/session.service';
import { IdService } from '../services/id.service';

@Injectable()
export class RequestHeaderInterceptor implements HttpInterceptor {
  constructor(
    private translate: TranslateService,
    private sessionService: SessionService,
    private idService: IdService,
  ) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const headers = request.headers
      .set('Accept-Language', this.translate.currentLang)
      .set('X-SSC-SessionId', this.sessionService.getSessionId() || '')
      .set('X-SSC-RequestId', this.idService.generateRandomId());
    return next.handle(request.clone({ headers }));
  }
}
